import React, { createElement, Fragment, useEffect, useState } from 'react';
import Entry from '../position-modules/Entry';
import { stringToNumber } from '../../special/numberConverter';
import { Box, Collapse, IconButton, useTheme } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { tokens } from '../../../global/theme/tokens';
import { useSortable } from '@dnd-kit/sortable';
import DeleteIcon from '@mui/icons-material/Delete';

export const PositionsRow = ({
  props,
  onChange,
  onFocus,
  item,
  items,
  index,
  columns,
  showVars,
  descriptionVars,
  imageType,
  imageApiFilter,
  collapseModules,
  openAmount,
  onCreate,
  className,
  onDelete,
  isDragging,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const [expand, setExpand] = useState(item.expand || false);
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    if (isDragging && isHovering) setIsHovering(false);
  }, [isDragging]);

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.sortId });

  // change
  function handleChange(e, col) {
    var newItems = items;
    if (col.number) {
      newItems[index][col.key] = stringToNumber(
        e.target.value,
        col.decimalPlaces ? col.decimalPlaces : 2
      );
    } else {
      newItems[index][col.key] = e.target.value;
    }
    onChange([...newItems]);
  }

  function handleUnitChange(e) {
    var newItems = items;
    newItems[index].unit = e.target.value;
    onChange([...newItems]);
  }

  function handleDefaultChange(value, key) {
    var newItems = items;
    newItems[index][key] = value;
    onChange([...newItems]);
  }

  function toggleExpand() {
    handleChange({ target: { value: !expand } }, { key: 'expand' });
    setExpand(!expand);
  }

  return (
    <Fragment>
      <tr
        {...props}
        ref={setNodeRef}
        {...listeners}
        {...attributes}
        style={{
          transition,
          cursor: 'pointer',
        }}
        className={className + ' ' + (item.orderId ? 'order-position' : '')}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        {collapseModules && (
          <td>
            <IconButton onClick={() => toggleExpand()}>
              <ExpandMoreIcon
                sx={{
                  transform: `rotate(${expand ? '-180deg' : '0deg'})`,
                  transition: '0.2s',
                }}
              />
            </IconButton>
          </td>
        )}
        {columns.map((col, i) => {
          return (
            <Fragment key={'Fragment' + item.position + i}>
              {col.key == 'delete' ? (
                <td>
                  <IconButton
                    className={`${
                      isHovering && !isDragging && onDelete
                        ? 'visible'
                        : 'invisible'
                    }`}
                    onClick={() => onDelete(item)}
                  >
                    <DeleteIcon sx={{ color: 'red' }} />
                  </IconButton>
                </td>
              ) : (
                <Entry
                  key={'' + item.position + i}
                  imageType={imageType}
                  imageApiFilter={imageApiFilter}
                  col={col}
                  item={items[index]}
                  onFocus={(ref) => onFocus(ref, col.key)}
                  onChange={(e) => handleChange(e, col)}
                  onUnitChange={handleUnitChange}
                >
                  {item[col.key]}
                </Entry>
              )}
            </Fragment>
          );
        })}
      </tr>
      {collapseModules && (
        <tr className={className}>
          <td colSpan={999}>
            {expand && (
              <Collapse in={expand} className="px-6">
                <Box
                  className="w-full grid gap-4 p-4 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 rounded-lg " //mb-3 mt-1"
                  sx={{
                    borderColor: colors.selected,
                    borderWidth: '1px',
                  }}
                >
                  {collapseModules.map((module, index) =>
                    createElement(module.component, {
                      key: item.id + 'module' + index,
                      openAmount,
                      imageType,
                      imageApiFilter,
                      position: item,
                      data: item[module.key],
                      moduleKey: module.key,
                      onFocus: (ref) => onFocus(ref, module.key),
                      unit: module.unit,
                      label: module.label,
                      defaultValue: module.value,
                      decimalPlaces: module.decimalPlaces,
                      descriptionVars,
                      showVars,
                      onChange: (value, manuelKey) =>
                        handleDefaultChange(value, manuelKey || module.key),
                      onCreate,
                      textBlockType: module.textBlockType,
                    })
                  )}
                </Box>
              </Collapse>
            )}
          </td>
        </tr>
      )}
    </Fragment>
  );
};
